import googlePhoneNumber from 'google-libphonenumber'
import i18n from 'i18next'
import jwt_decode from 'jwt-decode'
import queryString from 'query-string'
import { v4 as uuidv4 } from 'uuid'

import React from 'react'
import { Helmet } from 'react-helmet'
import { scroller } from 'react-scroll'

import moment from 'moment'

import { COUNTRY_CODE_SUPPORT, DEFAULT_VALUE, FTL_WEB_APP, FTL_WEB_APP_PH, LOCAL_STORAGE } from '../constants'
import { defaultCountriesData } from '../constants/countries.const'
import { inRange } from './compare'
import { crossStorageUtils } from './crossStorage'
import { getCookie, setCookie } from './storage/cookie.helper'

const { DEFAULT_WIDTH_DPI, DEFAULT_HEIGHT_DPI, DEFAULT_SIZE_OF_KB } = DEFAULT_VALUE

/**

/**
 * Get list countriesData with format
 * @param {countriesData} countriesData
 */
export const formatCountriesData = (countriesData) =>
  countriesData.map((country) => ({
    name: country[0],
    iso2: country[1],
    dialCode: country[2],
    priority: country[3] || 0,
    areaCodes: country[4] || null,
  }))

/**
 * Get dialCode with countryCode
 * @param {countryCode} countryCode
 */

export const getDialCodeWithCountryCode = (countryCode) => {
  const countryList = formatCountriesData(defaultCountriesData)
  const country = countryList.find((item) => item.iso2 === countryCode)
  return country?.dialCode
}

export const getCountryCodeWithDialCode = (dialCode) => {
  const countryList = formatCountriesData(defaultCountriesData)
  const country = countryList.find((item) => item.dialCode === dialCode)
  return country?.iso2 || localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)
}

/**
 * Get dialCode with countryCode
 * @param {phoneNumber} phoneNumber
 * @param {countryCode} countryCode
 */

export const validatePhoneNumberWithCountry = (phoneNumber, countryCode) => {
  try {
    const phoneUtils = googlePhoneNumber.PhoneNumberUtil.getInstance()
    const phoneObject = phoneUtils.parse(phoneNumber, countryCode)
    return phoneUtils.isValidNumberForRegion(phoneObject, countryCode)
  } catch (ex) {
    return false
  }
}

export const deleteAllStorage = () => {
  // Delete localStorage
  crossStorageUtils.setAccessToken('')
  localStorage.removeItem(LOCAL_STORAGE.ACCOUNT_INFO)
  sessionStorage.clear()
}

const hideError = () => {
  const errorCom = document.getElementById('errorMessage')
  if (errorCom && !errorCom.className.includes('visible')) {
    errorCom.children[1].innerText = ''
    errorCom.classList.add('collapse')
  }
}

export const showError = (message, className) => {
  const errorCom = document.getElementById('errorMessage')
  errorCom.classList.add(className)
  if (errorCom && errorCom.className.includes('collapse')) {
    errorCom.children[1].innerText = message
    errorCom.classList.remove('collapse')
    setTimeout(() => {
      hideError()
    }, 3000)
  }
}

export const truncate = (s = '', maxLength = 12) => {
  return s.length > maxLength ? `${s.slice(0, maxLength)}...` : s
}

export const showErrorMessage = (message, timeout = 3000) => {
  showError(message)
  setTimeout(hideError, timeout)
}

export const convertFilesToListImage = (files) => {
  const listImage = []
  for (let i = 0; i < files.length; i++) {
    listImage.push(files[i].imageUrl)
  }
  return listImage
}

export const configHeadHelmet = () => {
  const country = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY) || 'id'
  const language = localStorage.getItem(LOCAL_STORAGE.DEFAULT_LANGUAGE) || 'id'
  const isPh = country === 'ph'

  return (
    <Helmet htmlAttributes={{ lang: language }}>
      <title>{isPh ? i18n.t('common.transportifyTitle') : i18n.t('common.titleCargo')}</title>
      <link rel="icon" href={`/${isPh ? 'favicon_transportify' : 'favicon'}.ico`} />
    </Helmet>
  )
}

export const getResolutionDPI = (originWidth, originHeight) => {
  let width, height, scaleDPI
  if (originWidth > originHeight && originWidth > DEFAULT_WIDTH_DPI) {
    scaleDPI = originWidth / DEFAULT_WIDTH_DPI
    width = parseInt(originWidth / scaleDPI, 10)
    height = parseInt(originHeight / scaleDPI, 10)
  } else if (originHeight > originWidth && originHeight > DEFAULT_HEIGHT_DPI) {
    scaleDPI = originHeight / DEFAULT_HEIGHT_DPI
    width = parseInt(originWidth / scaleDPI, 10)
    height = parseInt(originHeight / scaleDPI, 10)
  } else {
    width = originWidth
    height = originHeight
  }

  return {
    width,
    height,
  }
}

export const compressImage = (img, originWidth, originHeight, qualityImage = 0.8) => {
  if (window.File && window.FileReader && window.FileList && window.Blob) {
    const canvas = document.createElement('canvas')
    const { width, height } = getResolutionDPI(originWidth, originHeight)
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, originWidth, originHeight, 0, 0, canvas.width, canvas.height)
    return canvas.toDataURL('image/jpeg', qualityImage)
  }
  return null
}

export const getQualityImage = (size) => {
  let qualityImage
  if (inRange(size, 200, DEFAULT_SIZE_OF_KB)) {
    qualityImage = 0.5
  } else if (inRange(size, DEFAULT_SIZE_OF_KB + 1, DEFAULT_SIZE_OF_KB * 2)) {
    qualityImage = 0.4
  } else if (inRange(size, DEFAULT_SIZE_OF_KB * 2 + 1, DEFAULT_SIZE_OF_KB * 3)) {
    qualityImage = 0.3
  } else if (inRange(size, DEFAULT_SIZE_OF_KB * 3 + 1, DEFAULT_SIZE_OF_KB * 4)) {
    qualityImage = 0.2
  } else {
    qualityImage = 0.15
  }
  return qualityImage
}

/**
 *
 * @param {string} dataurl this is url of data want to convert to Object
 * @param {string} filename file name after convert
 */
export const dataURLtoFile = (dataurl, filename) => {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

/**
 *  handle upload file image and resize
 * @param {*} listFilesChange
 */

export const getSessionId = () => {
  let sessionId = getCookie('device_id')
  if (!sessionId) {
    sessionId = uuidv4()
    setCookie('device_id', sessionId)
  }
  return sessionId
}

export const scrollToElement = (scrollTo, containerId) => {
  scroller.scrollTo(scrollTo, {
    delay: 100,
    containerId: containerId,
    smooth: true,
    duration: 1000,
  })
}

export const addLocalStorage = (batch, BATCH_STATUS_PARTIALLY_CONFIRMED, BATCH_STATUS_UNCONFIRMED) => {
  const getStatus = localStorage.getItem('batch_status')
  const getItem = parseInt(localStorage.getItem('batch_id'), 10)

  if (getStatus || getItem) {
    const checkLocalStatus = [BATCH_STATUS_PARTIALLY_CONFIRMED, BATCH_STATUS_UNCONFIRMED].includes(getStatus)
    const checkBatchStatus = [BATCH_STATUS_PARTIALLY_CONFIRMED, BATCH_STATUS_UNCONFIRMED].includes(batch.status)
    if (checkLocalStatus === checkBatchStatus && getItem === parseInt(batch.id, 10)) {
      localStorage.setItem('batch_retry', true)
    }
  }
}

export const checkLocalStorageToFlash = (batch, BATCH_STATUS_PARTIALLY_CONFIRMED, BATCH_STATUS_UNCONFIRMED) => {
  const getStatus = localStorage.getItem('batch_status')
  const getItem = parseInt(localStorage.getItem('batch_id'), 10)
  const getRetry = localStorage.getItem('batch_retry')
  const checkLocalStatus = [BATCH_STATUS_PARTIALLY_CONFIRMED, BATCH_STATUS_UNCONFIRMED].includes(getStatus)
  const checkBatchStatus = [BATCH_STATUS_PARTIALLY_CONFIRMED, BATCH_STATUS_UNCONFIRMED].includes(batch.status)
  if (getStatus || getItem) {
    if (checkLocalStatus === checkBatchStatus && getItem === parseInt(batch.id, 10)) {
      if (getRetry === 'true') {
        return true
      } else {
        return false
      }
    } else if (checkLocalStatus === checkBatchStatus) {
      return true
    }
  } else if (checkBatchStatus) {
    return true
  }
}

const hourFormatByCountry = (countryCode) => {
  let formatHour

  switch (countryCode.toUpperCase()) {
    case 'PH':
      formatHour = 'h'
      break
    default:
      formatHour = 'H'
  }

  return formatHour
}

export const formatDateTime = (dateTime, countryCode = 'id') => {
  const formatHour = hourFormatByCountry(countryCode)
  const month = i18n.t(`common.format_short_month.month_${moment(dateTime).month()}`)

  return {
    date: moment(dateTime).format(`D-[${month}]-YY`),
    time: moment(dateTime).format(`${formatHour}:mm`),
    fullDate: moment(dateTime).format(`D-[${month}]-YYYY`),
  }
}

export const getLanguage = (language) =>
  ({
    vi: 'vi-VN',
    th: 'th-TH',
    id: 'id-ID',
    en: 'en-US',
  })[language]

export const gotoStep1 = (queryParams = {}) => {
  const token = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
  const language = localStorage.getItem(LOCAL_STORAGE.DEFAULT_LANGUAGE)
  const query = queryString.stringify({
    lang: language || 'en',
    ...queryParams,
    ...(token ? { token: token } : {}),
  })
  window.location.replace(`${getFTLWebAppDomain()}?${query}`)
}

export const formatNumberByCountry = (number = 0, precision = 0) => {
  if (!number) return 0
  let countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY) || 'id'
  return parseFloat(parseFloat(+number).toFixed(precision)).toLocaleString(countryCode)
}

export const defaultCenter = () => {
  const country = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)
  let center
  switch (country) {
    case 'ph':
      center = {
        lat: 14.5816487,
        lng: 121.0608002,
      }
      break
    case 'th':
      center = {
        lat: 13.7627583,
        lng: 100.5348958,
      }
      break
    case 'id':
      center = {
        lat: -6.17537,
        lng: 106.82711,
      }
      break
    default:
      center = {
        lat: 10.797176,
        lng: 106.65923,
      }
  }
  return center
}

export const appName = () => {
  const countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)
  return countryCode === 'ph' ? 'Transportify' : 'Deliveree'
}

export const getCompanyAccount = (companyId, account) =>
  account?.accounts?.find((item) => item.company_id === companyId)

export const getFTLWebAppDomain = () => {
  const countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)
  return countryCode === COUNTRY_CODE_SUPPORT.PH && FTL_WEB_APP_PH ? FTL_WEB_APP_PH : FTL_WEB_APP
}

export const changeDate = (date) => {
  const lastCharater = date.charAt(date.length - 1)
  if (lastCharater !== 'Z') {
    date = `${date}Z`
  }
  return moment(date).format(' h:mm a, MMMM Do YYYY')
}

/**
 * Parse object into FormData
 * @param {Object} params
 */
export const objectToFormData = (params = {}) => {
  const formData = new FormData()
  Object.keys(params).forEach((key) => {
    formData.append(key, params[key])
  })
  return formData
}

export const parseJwt = (token) => {
  const isJWT = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(token)
  return isJWT && token && jwt_decode(token)
}

export const scrollIntoView = (element) => document.getElementById(element).scrollIntoView({ behavior: 'smooth' })

export const getCompanyId = (accounts) => {
  return accounts?.currentCompanyId
}

const snakeToCamel = (snakeStr) => {
  return snakeStr.replace(/_([a-z])/g, (_, char) => char.toUpperCase())
}

export const convertToCamelCase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertToCamelCase(item))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const camelKey = snakeToCamel(key)
      acc[camelKey] = convertToCamelCase(obj[key])
      return acc
    }, {})
  }
  return obj
}
